import { useState, useEffect } from "react";

const KEY = "3dp_favoritos";
const EVENT = "3dp-favoritos-change";

function ler() {
  try { const value = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(value) ? value : []; } catch { return []; }
}

// Módulos favoritados pelo usuário (ids de tab) — persistido no dispositivo.
// Compartilhado entre o hub "Mais" (onde se marca) e a Home (onde aparece em destaque).
export function useFavoritos() {
  const [favoritos, setFavoritos] = useState(ler);

  useEffect(() => {
    const sync = () => setFavoritos(ler());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);

  const isFavorito = (id) => favoritos.includes(id);

  const toggleFavorito = (id) => {
    const current = ler();
    const next = current.includes(id) ? current.filter(x => x !== id) : [...current, id];
    setFavoritos(next);
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
    window.dispatchEvent(new Event(EVENT));
  };

  return { favoritos, isFavorito, toggleFavorito };
}
